import React from 'react';
import _ from 'lodash';

import { useItemSelectFieldQuery } from 'generated/graphql';



export interface IInventoryItem {
  id: string;
  displayName: string;
}

export interface IData {
  objects: IInventoryItem[];
}

export function useQuery(hasListingsForStoreId?: string) {
  const queryTuple = useItemSelectFieldQuery({
    variables: {
      options: {
        filter: {
          hasListingForStoreId: hasListingsForStoreId
        }
      }
    }
  });

  const wrappedTuple = React.useMemo(() => {
    const data: IData = {
      objects: _.map(queryTuple.data?.items.nodes ?? [], (node): IInventoryItem => ({
        id: node.id,
        displayName: `${node.name} (${node.sku})`
      }))
    };

    return {
      loading: queryTuple.loading,
      data,
      refetch: async () => {
        queryTuple.refetch({});
      }
    };
  }, [queryTuple]);

  return wrappedTuple;
}
